import { isEmpty } from '@soltalabs/ramda-extra'
import moment from 'moment'
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  updateSelectedForecastTime,
  getForecastStartTimes,
  getIsFetchForecastsLoading,
} from '../../../modules/forecast'
import { getIsAddJobLoading, getIsDeleteJobLoading } from '../../../modules/job'

import { ForecastSliderView } from './view'

function ForecastSlider() {
  const dispatch = useDispatch()
  const forecastStartTimes = useSelector(getForecastStartTimes)
  const isFetchForecastsLoading = useSelector(getIsFetchForecastsLoading)
  const isAddJobLoading = useSelector(getIsAddJobLoading)
  const isDeleteJobLoading = useSelector(getIsDeleteJobLoading)

  function onSliderValueChange(e, value) {
    return dispatch(updateSelectedForecastTime(moment.unix(value).toISOString()))
  }

  const isLoadingSlider =
    isEmpty(forecastStartTimes) ||
    isAddJobLoading ||
    isDeleteJobLoading ||
    isFetchForecastsLoading

  return (
    <ForecastSliderView
      forecastStartTimes={forecastStartTimes}
      onSliderValueChange={onSliderValueChange}
      isLoadingSlider={isLoadingSlider}
      isFetchForecastsLoading={isFetchForecastsLoading}
    />
  )
}

export { ForecastSlider }
